/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit, HostListener } from '@angular/core';
import { NbIconLibraries } from '@nebular/theme';
import { Store } from '@ngrx/store';
import { tenantSettingChanged, tenantSettingError } from './@core/ng-store/tenant-setting/tenant-setting.action';
import { TenantProvider } from './@core/providers/tenant.provider';
import { HeaderTitleService } from './@core/services/header-title.service';
import { TenantService } from './@core/services/tenant.service';
import {
  BrowserStorageService,
  DE_LOCAL_KEYS,
} from './@core/store/localStorage.service';
import { AppState } from './app.module';
import { TenantSettingModel } from './shared/models/tenant-setting.model';
import { environment } from 'environments/environment';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
  standalone: false
})
export class AppComponent implements OnInit {
  favIcon: HTMLLinkElement = document.querySelector('#appIcon');

  constructor(
    private iconLibraries: NbIconLibraries,
    private headerTitleService: HeaderTitleService,
    private localStorage: BrowserStorageService,
    private tenantService: TenantService,
    private store: Store<AppState>,
    private tenantProvider: TenantProvider
  ) {
    this.iconLibraries.registerFontPack('solid', {
      packClass: 'fas',
      iconClassPrefix: 'fa',
    });
    this.iconLibraries.setDefaultPack('solid');
    this.iconLibraries.registerSvgPack('menu-sidebar-icon', {
      gas:
        // tslint:disable-next-line: max-line-length
        '<svg  xmlns="http://www.w3.org/2000/svg" width="11.312" height="20" viewBox="0 0 11.312 20"><defs></defs><g transform="translate(-98.304)"><g transform="translate(98.304)"><g transform="translate(0)"><path fill="currentColor" d="M106.562,4.1V2.805h.294a1.41,1.41,0,0,0,1.4-1.4,1.41,1.41,0,0,0-1.4-1.4h-5.792a1.41,1.41,0,0,0-1.4,1.4,1.41,1.41,0,0,0,1.4,1.4h.294V4.1A3.266,3.266,0,0,0,98.3,7.353V10.9h11.312V7.353A3.266,3.266,0,0,0,106.562,4.1Zm-1.131-.023h-.9v-.5h-1.131v.5h-.9V2.783h2.941Z" transform="translate(-98.304)"/></g></g><g transform="translate(98.304 12.036)"><g transform="translate(0)"><path fill="currentColor" d="M98.3,272.384V276a3.3,3.3,0,0,0,1.81,2.941v1.4h7.692v-1.4a3.3,3.3,0,0,0,1.81-2.941v-3.62Z" transform="translate(-98.304 -272.384)"/></g></g></g></svg>',
      steerwheel:
        // tslint:disable-next-line: max-line-length
        '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve"><g><g id="steering_x5F_wheel"><path fill="currentColor" d="M16,0C7.164,0,0,7.164,0,16s7.164,16,16,16s16-7.164,16-16S24.836,0,16,0z M16,4c5.207,0,9.605,3.354,11.266,8H4.734C6.395,7.354,10.793,4,16,4z M16,18c-1.105,0-2-0.895-2-2s0.895-2,2-2s2,0.895,2,2S17.105,18,16,18z M4,16c5.465,0,9.891,5.266,9.984,11.797C8.328,26.828,4,21.926,4,16z M18.016,27.797C18.109,21.266,22.535,16,28,16C28,21.926,23.672,26.828,18.016,27.797z"/></g></g></svg>',
      tenant:
        '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20.037" viewBox="0 0 20 20.037"><defs><style>.a{fill:currentColor;}.b{clip-path:url(#a);}</style><clipPath id="a"><rect class="a" width="20" height="20.037" transform="translate(0 0)"/></clipPath></defs><g transform="translate(0 0)"><g class="b"><path class="a" d="M12.072,6.947a1.868,1.868,0,1,0,1.321.547,1.855,1.855,0,0,0-1.321-.547"/><path class="a" d="M18.434,4.182l-7-3.815a3,3,0,0,0-2.877,0l-7,3.815A3.006,3.006,0,0,0,0,6.82V17.032a3,3,0,0,0,3,3.005H17a3.006,3.006,0,0,0,3-3.005V6.82a3.007,3.007,0,0,0-1.566-2.638m-2.892,6.1a3.768,3.768,0,0,1-5.281,1.835L7.874,14.506l.883.883a.367.367,0,0,1,.073.414.268.268,0,0,1-.059.083l-.995,1a.367.367,0,0,1-.412.072A.272.272,0,0,1,7.28,16.9l-.9-.9-.623.624a.367.367,0,0,1-.413.072.274.274,0,0,1-.084-.058l-1.01-1.009a.281.281,0,0,1-.058-.084.368.368,0,0,1,.073-.413l4.507-4.5a3.77,3.77,0,0,1-.464-1.813,3.765,3.765,0,1,1,7.233,1.468"/></g></g></svg>',
      user:
        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="16.002" viewBox="0 0 20 16.002"><defs><style>.a{fill:currentColor;}</style></defs><path class="a" d="M19.08,11.667a3.666,3.666,0,0,0,0-1.331l.806-.466a.226.226,0,0,0,.1-.266A4.69,4.69,0,0,0,18.952,7.81a.228.228,0,0,0-.281-.044l-.806.466a3.669,3.669,0,0,0-1.153-.666V6.635a.228.228,0,0,0-.178-.222,4.715,4.715,0,0,0-2.069,0,.228.228,0,0,0-.178.222v.931a3.669,3.669,0,0,0-1.153.666l-.806-.466a.229.229,0,0,0-.281.044A4.69,4.69,0,0,0,11.007,9.6a.23.23,0,0,0,.1.266l.806.466a3.666,3.666,0,0,0,0,1.331l-.806.466a.226.226,0,0,0-.1.266,4.713,4.713,0,0,0,1.038,1.794.228.228,0,0,0,.281.044l.806-.466a3.669,3.669,0,0,0,1.153.666v.931a.228.228,0,0,0,.178.222,4.715,4.715,0,0,0,2.069,0,.228.228,0,0,0,.178-.222v-.931a3.669,3.669,0,0,0,1.153-.666l.806.466a.229.229,0,0,0,.281-.044A4.69,4.69,0,0,0,19.99,12.4a.23.23,0,0,0-.1-.266Zm-3.579.85A1.516,1.516,0,1,1,17.017,11,1.517,1.517,0,0,1,15.5,12.517ZM7,8A4,4,0,1,0,3,4,4,4,0,0,0,7,8Zm6.288,7.079c-.072-.038-.144-.081-.213-.122l-.247.144a1.226,1.226,0,0,1-1.516-.228A5.7,5.7,0,0,1,10.057,12.7a1.222,1.222,0,0,1,.559-1.428l.247-.144q0-.122,0-.244l-.247-.144a1.221,1.221,0,0,1-.559-1.428c.028-.091.069-.181.1-.272C10.039,9.029,9.923,9,9.8,9H9.279A5.44,5.44,0,0,1,4.722,9H4.2A4.2,4.2,0,0,0,0,13.2v1.3A1.5,1.5,0,0,0,1.5,16h11a1.5,1.5,0,0,0,.85-.266,1.217,1.217,0,0,1-.063-.369Z"/></svg>',
      resendInvoice:
        `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="18" viewBox="0 0 13 18"><g transform="translate(-1114.954 -954.89)"><g transform="translate(1114.954 954.89)"><g transform="translate(8.839 0)"><path fill="currentColor" d="M1174.523,962.422v-3.485l4.161,4.161H1175.2A.676.676,0,0,1,1174.523,962.422Z" transform="translate(-1174.523 -958.937)" fill:currentColor;/></g><g transform="translate(0 0)"><path fill="currentColor" d="M1130.569,964.061h-.3a.884.884,0,0,1-.887-.881v-4.244h-6.425a1.405,1.405,0,0,0-1.411,1.4v15.2a1.405,1.405,0,0,0,1.411,1.4h10.179a1.405,1.405,0,0,0,1.41-1.4V964.061Zm1.574,5.973-2.92,2.671a.248.248,0,0,1-.266.045.242.242,0,0,1-.144-.219v-1.69h-4.223a.239.239,0,0,1-.243-.241v-1.449a.239.239,0,0,1,.243-.242h4.223v-1.69a.23.23,0,0,1,.144-.219.261.261,0,0,1,.266.038l2.92,2.641a.246.246,0,0,1,.076.174A.262.262,0,0,1,1132.144,970.035Z" transform="translate(-1121.542 -958.937)" fill:currentColor;/></g></g></g></svg>`
    });

    this.headerTitleService.clearTitle();
    this.tenantService.getSetting()
      .subscribe(x => {
        if (x) {
          const settings = new TenantSettingModel(x);
          this.store.dispatch(tenantSettingChanged(settings));

          if (this.tenantProvider.getSubdomain() !== 'admin' && settings.logoPath) {
            this.favIcon.href = settings.logoPath;
          }
        } else {
          this.store.dispatch(tenantSettingChanged(null));
        }
      }, error => {
        this.store.dispatch(tenantSettingError());
      });
  }

  ngOnInit() {
    // this.analytics.trackPageViews();
    // this.loadGoogleMaps();
  }

  // Remove cached filter and search after refreshing browser
  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler() {
    this.localStorage.remove(DE_LOCAL_KEYS.filterCacheKey);
    this.localStorage.remove(DE_LOCAL_KEYS.searchCacheKey);
  }

  // loadGoogleMaps(): void {
  //   if (!document.getElementById('googleMapsScript')) {
  //     const script = document.createElement('script');
  //     script.id = 'googleMapsScript';
  //     script.async = true;
  //     script.defer = true;
  //     script.text = ``
  //     document.body.appendChild(script);
  //   }
  // }
}
